import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const FinalCTA = () => {
  const scrollToCalendar = () => {
    document.getElementById('booking-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-12 md:py-16 bg-slate-50 border-t border-slate-200">
      <div className="max-w-5xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3">
          Ready to Stop Losing Calls After Hours?
        </h2>
        <p className="text-lg md:text-xl text-slate-600 mb-8">
          Start a free 14-day pilot. No setup fee. No commitment. See it handle real calls before you pay anything.
        </p>
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4 mb-8 text-left bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
          {[
            { step: 'Step 1', desc: 'Book a 15-min discovery call' },
            { step: 'Step 2', desc: 'We build your custom AI agent' },
            { step: 'Step 3', desc: 'Pilot goes live in 48–72 hours' },
            { step: 'Step 4', desc: "Review results. Pay only if you're satisfied." },
          ].map((s, i) => (
            <div key={i} className="p-2">
              <div className="font-bold text-slate-900 mb-1">{s.step}</div>
              <p className="text-sm text-slate-600">{s.desc}</p>
            </div>
          ))}
        </div>
        <button
          onClick={scrollToCalendar}
          className="w-full md:w-auto bg-green-700 text-white px-10 py-5 rounded-xl text-xl font-bold hover:bg-green-800 transition-all shadow-xl shadow-green-700/20 mb-6"
        >
          Book a 15-Minute Discovery Call
        </button>
        <p className="text-slate-500 mb-6 max-w-lg mx-auto">
          No credit card required. No obligation. Just a 15-minute conversation about your business.
        </p>
        <div className="flex flex-col items-center space-y-3">
          <div className="inline-flex items-center gap-2 bg-green-50 border border-green-100 px-4 py-2 rounded-full text-green-800 text-sm font-medium text-center">
            <SafeIcon icon={FiCheckCircle} className="w-4 h-4 flex-shrink-0" />
            14-day free pilot + 30-day money-back guarantee
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;